var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      class: { "is-active": _vm.isActive },
      attrs: { "data-component": "app-launcher-versions-option" },
      on: {
        click: function ($event) {
          return _vm.$emit("click")
        },
      },
    },
    [
      _c("span", { attrs: { "data-text": "version" } }, [
        _vm._v("\n    " + _vm._s(_vm.version) + "\n  "),
      ]),
      _vm._v(" "),
      _vm.tags.length
        ? _c(
            "div",
            { staticClass: "tags" },
            _vm._l(_vm.tags, function (tag, index) {
              return _c(
                "or-tag",
                { key: index, attrs: { "data-color": tag.color } },
                [_vm._v("\n      " + _vm._s(tag.content) + "\n    ")]
              )
            }),
            1
          )
        : _vm._e(),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }